// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/dcimage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outerMostLeaderboardDiv {
  padding-left: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Ensure the path is correct */
  background-size: cover;
  background-position: center;
  width: 100%;
  position: relative; /* Ensure other elements can be positioned correctly */
  overflow: hidden;
}

.OuterleaderboardDiv {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 470px;
  margin-bottom: 100px;
}

.InnerleaderboardDiv {
  position: absolute;
  display: flex;
  margin-top: 20px;
  color: aqua;
}

.leaderboardHeading {
  margin-top: 60px;
  color: #000;
  font-family: Thicker;
  font-size: 54px;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}

.leaderboardSubHeading {
  color: #000;
  font-family: Thicker;
  font-size: 54px;
  font-style: normal;
  font-weight: 600;
  line-height: 111%;
  text-transform: capitalize;
}

.leaderboardSubHeader {
  display: flex;
}

.leaderboardImage {
  margin: 0px 10px;
  /* margin-bottom: 30px; */
  width: 285px;
  background-color: white;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.leaderboardImage > img {
  max-width: 100%;
  height: 300px;
  object-fit: cover;
}
.leaderboardImage p{
  margin-left: 10px;
}
.winnerName, .winnerYear {
  width: 100%;
  color: black;
  font-size: 16px;
  margin-top: 10px;
  text-decoration: none !important;
  font-family: thicker !important;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.customWinnerIcon {
  width: 20px; /* Adjust size as needed */
  height: 20px; /* Adjust size as needed */
  margin-right: 8px; /* Space between icon and text */
}


@media screen and (max-width: 650px) {
  .leaderboardHeading {
    font-size: 16px;
    margin-top: 20px;
  }
  .leaderboardSubHeading {
    font-size: 17px;
  }
  .leaderboardIcon {
    margin-top: 1px;
    margin-left: 8px;
    width: 20px !important;
    height: 20px !important;
    cursor: pointer;
  }
}

section {
  display: flex;
  animation: swipe var(--speed) linear infinite backwards;
}

@keyframes swipe {
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(-100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/winnerList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yDAAiD,EAAE,+BAA+B;EAClF,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB,EAAE,sDAAsD;EAC1E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,0BAA0B;EACxC,iBAAiB,EAAE,gCAAgC;AACrD;;;AAGA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".outerMostLeaderboardDiv {\n  padding-left: 30px;\n  background-image: url('../../assets/dcimage.png'); /* Ensure the path is correct */\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  position: relative; /* Ensure other elements can be positioned correctly */\n  overflow: hidden;\n}\n\n.OuterleaderboardDiv {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  height: 470px;\n  margin-bottom: 100px;\n}\n\n.InnerleaderboardDiv {\n  position: absolute;\n  display: flex;\n  margin-top: 20px;\n  color: aqua;\n}\n\n.leaderboardHeading {\n  margin-top: 60px;\n  color: #000;\n  font-family: Thicker;\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.leaderboardSubHeading {\n  color: #000;\n  font-family: Thicker;\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 111%;\n  text-transform: capitalize;\n}\n\n.leaderboardSubHeader {\n  display: flex;\n}\n\n.leaderboardImage {\n  margin: 0px 10px;\n  /* margin-bottom: 30px; */\n  width: 285px;\n  background-color: white;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n\n.leaderboardImage > img {\n  max-width: 100%;\n  height: 300px;\n  object-fit: cover;\n}\n.leaderboardImage p{\n  margin-left: 10px;\n}\n.winnerName, .winnerYear {\n  width: 100%;\n  color: black;\n  font-size: 16px;\n  margin-top: 10px;\n  text-decoration: none !important;\n  font-family: thicker !important;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n.customWinnerIcon {\n  width: 20px; /* Adjust size as needed */\n  height: 20px; /* Adjust size as needed */\n  margin-right: 8px; /* Space between icon and text */\n}\n\n\n@media screen and (max-width: 650px) {\n  .leaderboardHeading {\n    font-size: 16px;\n    margin-top: 20px;\n  }\n  .leaderboardSubHeading {\n    font-size: 17px;\n  }\n  .leaderboardIcon {\n    margin-top: 1px;\n    margin-left: 8px;\n    width: 20px !important;\n    height: 20px !important;\n    cursor: pointer;\n  }\n}\n\nsection {\n  display: flex;\n  animation: swipe var(--speed) linear infinite backwards;\n}\n\n@keyframes swipe {\n  0% {\n    transform: translate(0);\n  }\n  100% {\n    transform: translate(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
